import { TemplateConfig } from '../types';

export const activeReunionConfig: TemplateConfig = {
  id: 'active-reunion',
  name: '主动复合牌阵',
  description: '分析分手后复合的可能性、障碍和方法',
  cardCount: 9,
  
  fieldDefaults: {
    title: '主动复合牌阵',
    customerQuestion: '已经分手想复合却不知道怎么挽回。对方对复合有什么顾忌呢？我应该如何做？',
    cardPlaceholders: [
      '请输入第 2 列第 2 张牌',
      '请输入第 2 列第 3 张牌',
      '请输入第 2 列第 1 张牌',
      '请输入第 1 列第 1 张牌',
      '请输入第 3 列第 1 张牌',
      '请输入第 4 列第 1 张牌',
      '请输入第 4 列第 2 张牌',
      '请输入第 4 列第 3 张牌',
      '请输入第 4 列第 4 张牌'
    ],
    cardInfos: [
      '对方还爱我吗',
      '对方有新欢了吗',
      '对方跟我复合的顾虑点是什么',
      '对方希望我改变什么',
      '我怎么和对方谈复合',
      '复合后对方会对我更好吗',
      '如何维持我们之间的感情',
      '我和对方的结局',
      '对方近期会主动找我复合吗'
    ]
  },
  
  disabledFields: ['title', 'customerQuestion', 'cardCount', 'cardInfos'],
  
  generateOptions: {
    normal: true,
    thinking: true
  },
  
  ui: {
    color: '#f759ab',
    backgroundColor: '#fff0f6',
    icon: '💕'
  }
};